import { render, staticRenderFns } from "./StocktakingPlan.vue?vue&type=template&id=b8384e18&scoped=true&"
import script from "./StocktakingPlan.vue?vue&type=script&lang=js&"
export * from "./StocktakingPlan.vue?vue&type=script&lang=js&"
import style0 from "./StocktakingPlan.vue?vue&type=style&index=0&id=b8384e18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8384e18",
  null
  
)

export default component.exports